import Grid from "@mui/material/Grid";
import AttributeCreation from "./AttributeCreation";
import React from "react";
import Button from "@mui/material/Button";
import cc_done from "../../_helper/cc_done";
import {styled} from "@mui/material/styles";
import Paper from "@mui/material/Paper";
import CharCreate from "../../_helper/charcreate";
import {s_char} from "../../_signals/s_char";

const Item = styled(Paper)(({theme}) => ({
    backgroundColor: '#fff', ...theme.typography.body2, padding: 4, height: '100%', textAlign: 'center', color: '#000',
}));

export default function AttributesCreation() {

    const calcRest = () => {
        let rest = CharCreate.points;
        let player = s_char.value;

        let mod = CharCreate.attrModCost.filter(e => e.mod === player.ges_c).shift();
        if (mod && mod.cost) rest = rest + mod.cost;

        mod = CharCreate.attrModCost.filter(e => e.mod === player.str_c).shift();
        if (mod && mod.cost) rest = rest + mod.cost;

        mod = CharCreate.attrModCost.filter(e => e.mod === player.zae_c).shift();
        if (mod && mod.cost) rest = rest + mod.cost;

        mod = CharCreate.attrModCost.filter(e => e.mod === player.wah_c).shift();
        if (mod && mod.cost) rest = rest + mod.cost;

        mod = CharCreate.attrModCost.filter(e => e.mod === player.wil_c).shift();
        if (mod && mod.cost) rest = rest + mod.cost;

        mod = CharCreate.attrModCost.filter(e => e.mod === player.cha_c).shift();
        if (mod && mod.cost) rest = rest + mod.cost;

        return rest;
    }

    return <Grid container style={{paddingTop: 4, paddingBottom: 4, alignItems: "stretch"}}
                 spacing={1}>

        <Grid item xs={12}>
            <Item>
                <span style={{color: calcRest() < 0 ? 'red' : 'black'}}>
                {'Attributsverteilung: verbleibende Punkte: ' + calcRest()}
                </span>
                {calcRest() === 0 ? <Button onClick={cc_done}>abschliessen</Button> : null}
            </Item>
        </Grid>

        <Grid item xs={12} sm={6}><Item><AttributeCreation attribute={'ges'}/></Item></Grid>
        <Grid item xs={12} sm={6}><Item><AttributeCreation attribute={'str'}/></Item></Grid>
        <Grid item xs={12} sm={6}><Item><AttributeCreation attribute={'zae'}/></Item></Grid>
        <Grid item xs={12} sm={6}><Item><AttributeCreation attribute={'wah'}/></Item></Grid>
        <Grid item xs={12} sm={6}><Item><AttributeCreation attribute={'wil'}/></Item></Grid>
        <Grid item xs={12} sm={6}><Item><AttributeCreation attribute={'cha'}/></Item></Grid>
    </Grid>
}